import { apiClient } from "features/shared/api/axiosInstance";
import type { OTPVerificationResponseDto } from "common/models/api/models/OTPVerificationResponseDto";
import type { VerifyOTPRequest } from "common/models/api/models/VerifyOTPRequest";

export const otpApi = {
    generate: () => apiClient.post("/api/otp/generate"),

    verify: (body: VerifyOTPRequest) => apiClient.post<OTPVerificationResponseDto>("/api/otp/verify", body),
};
